import { Button, CircularProgress, DialogActions } from "@mui/material";
import Alert from "@mui/material/Alert";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import Snackbar from "@mui/material/Snackbar";
import { useState } from "react";

const ModalProjectToDubbing = ({ open, setOpen, projectId }) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [statusUpload, setStatusUpload] = useState("");
  const [openToast, setOpenToast] = useState(false);

  const handleClose = () => {
    setOpen(false);
    setFile(null);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.name.endsWith(".srt")) {
      setFile(selectedFile);
    } else {
      alert("Please select a valid .srt file");
      setFile(null);
    }
  };

  const handleConvertToDubbing = async () => {
    if (!file) {
      alert("Please select an SRT file before uploading.");
      return;
    }

    setLoading(true);
    try {
      console.log("📡 Sending SRT file to execute dubbing...");
      
      const formData = new FormData();
      formData.append('srtFile', file);

      const response = await fetch(`${process.env.REACT_APP_URL}/api/projects/execute-dubbing/${projectId}`, {
        method: 'POST',
        body: formData
      });

      const data = await response.json();
      console.log("✅ Response from server:", data);

      if (data.status || response.ok) {
        setStatusUpload("success");
        setOpenToast(true);
        setTimeout(() => {
          handleClose();
          window.location.reload();
        }, 2000);
      } else {
        console.error("❌ Error executing dubbing:", data);
        setStatusUpload("error");
        setOpenToast(true);
      }
    } catch (error) {
      console.error("🔥 Error executing dubbing:", error);
      setStatusUpload("error");
      setOpenToast(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Snackbar
        open={openToast}
        autoHideDuration={3000}
        onClose={() => setOpenToast(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity={statusUpload === "success" ? "success" : "error"}>
          {statusUpload === "success" ? "Project converted to dubbing successfully" : "Error converting project to dubbing"}
        </Alert>
      </Snackbar>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          sx={{ color: "white", backgroundColor: "#28262E" }}
        >
          Convert to Dubbing Project
        </DialogTitle>
        <DialogActions
          sx={{
            color: "white",
            backgroundColor: "#28262E",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            padding: 3,
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : (
            <>
              <div style={{ color: "white", marginBottom: "10px", textAlign: "center" }}>
                Upload the SRT file to convert this project to Dubbing
              </div>
              <input 
                type="file" 
                accept=".srt" 
                onChange={handleFileChange}
                style={{ color: "white" }}
              />
              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                <Button
                  onClick={handleConvertToDubbing}
                  disabled={!file}
                  sx={{ color: "white", backgroundColor: "#8EC36A" }}
                >
                  Upload & Convert
                </Button>
                <Button
                  onClick={handleClose}
                  sx={{ color: "white", backgroundColor: "#952937" }}
                >
                  Cancel
                </Button>
              </div>
            </>
          )}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalProjectToDubbing;
